$(window).load(function(){
	loadDiv();
});
$(document).ready(function(){
	loadDiv();
});

function loadDiv() {
      setTimeout(function() {
        document.getElementById("checkout").style.display = 'block';
      }, 2000); // Delay of 3000 milliseconds (3 seconds)
      setTimeout(function() {
        document.getElementById("finalizing").style.display = 'none';
      }, 2000); // Delay of 3000 milliseconds (3 seconds)
    console.log('// Delay of 3000 milliseconds (3 seconds)');
}

/*
	Variable Functions ==========================================================
*/